if (!customElements.get('lure-sticky-atc')) {
  customElements.define(
    'lure-sticky-atc',
    class LureStickyAtc extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.mainButton = this.productInfo?.querySelector('.product-form__submit');
        this.button = this.querySelector('button');
        this.variantText = this.querySelector('[data-sticky-variant]');

        if (!this.mainButton || !this.button) return;

        this.button.addEventListener('click', () => this.mainButton.click());
        this.observer = new IntersectionObserver(([entry]) => {
          this.classList.toggle('is-visible', !entry.isIntersecting && window.scrollY > entry.boundingClientRect.top);
        });
        this.observer.observe(this.mainButton);

        this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.productInfo.dataset.section) return;
          this.sync();
        });

        this.sync();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.variantUnsubscriber?.();
      }

      sync() {
        const selectedOptions = Array.from(
          new Set(
            Array.from(
              this.productInfo.querySelectorAll(
                'variant-selects fieldset:not(.lure-single-option) input:checked'
              )
            ).map((input) => input.value)
          )
        );

        if (this.variantText) this.variantText.textContent = selectedOptions.join(' · ');
        this.button.disabled = this.mainButton.disabled;
        this.button.textContent = this.mainButton.textContent.trim();
      }
    }
  );
}
